import LabelCell from './LabelCell';
import type { IDictionaryItem } from '@/creditflowresearch/application/TableDictionaries';
import { EMPTY_CELL_STATE } from '@/creditflowresearch/ui/common/constants';

export interface IDictionaryLabelItem extends IDictionaryItem {
  color?: string | null,
}

interface IDictionaryLabelCellProps {
  category: IDictionaryLabelItem | null | undefined,
  subcategory: IDictionaryLabelItem | null | undefined,
  tooltipCategoryLabel?: 'name' | 'abbreviation',
  className?: string,
}

const DictionaryLabelCell = ({
  category,
  subcategory,
  tooltipCategoryLabel = 'name',
  className,
}: IDictionaryLabelCellProps) => {
  if (!category) {
    return (<>{ EMPTY_CELL_STATE }</>);
  }

  const categoryTooltipLabel = tooltipCategoryLabel === 'abbreviation'
    ? (category.abbreviation || category.name)
    : category.name;
  const tooltip = subcategory ? `${ categoryTooltipLabel }: ${ subcategory.name }` : category.name;
  const color = category?.color || undefined;

  return (
    <LabelCell
      className={ className }
      text={ category.abbreviation || category.name }
      tooltip={ tooltip }
      color={ color ?? undefined }
    />
  );
};

export default DictionaryLabelCell;
